import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function PrivateRoute({component: C, ...rest }) {
  const cprops = {...rest}
  const perm = cprops.perm

  const viewPermissions = JSON.parse(localStorage.getItem('perm'))
  let has_perm = perm && viewPermissions && viewPermissions.find(i => i === perm)

  let route = null;

  if (has_perm===undefined){
    route = <Redirect to={{pathname: "/map"}}/>
  }else{
    route =<Route {...rest} render={props => localStorage.getItem('user') ? (<C {...props} {...rest} />) :
    (<Redirect to={{ pathname: "/login", state: { referrer: props.location } }}/> ) }/>
  }
  return (
    route
  )}


export default PrivateRoute;

